import React, { useEffect } from 'react';
import QRCode from 'react-qr-code';
import { getConfiguration, getDatastoreWarName, getReservationCodeType } from '../../utils';
import { renderToString } from 'react-dom/server';
import { useGetBase64Img } from '../../printer/useGetBase64Img';
import { getEnv } from '../../env';
import $ from 'jquery';

function getBarcode(source) {
	let barcode = document.createElement('img');
	$(barcode).attr({
		style: 'height: 50px; width:100%; display:none;',
		id: 'barcode'
	});
	document.body.appendChild(barcode);
	window.JsBarcode('#barcode', source, {
		format: 'CODE128',
		height: 60
	});
	return $(barcode)[0].src;	
}

const stylePrintScript = `
		<style>
			@page { margin: 1px; }
			html {
				display:grid;
			}
			body {
				max-width:300px;
				justify-self:center;
			}
			.logosContainer{
				display:flex;
				justify-content:self;
			}
			.customerLogo{
				min-width: 60%;
				height: auto;
				max-width:170px;
			}
			.aamsLogo{
				width: 35%;
    			height: 20px;
    			margin-left: 5%;
    			align-self: center;
			}
			.codeContainer {
				display: grid;
				justify-content:center;
			}
			.codeContainer img {
				margin-top:5%;
			}
			.qrcodeLabel{
				justify-content: center;
    			display: grid;
    			font-weight: bold;
    			border-style: solid;
    			border-width: 1px;
   			 	width: 90px;
    			justify-self: center;
    			height: 25px;
    			align-content: center;
			}
		</style>
		<script>
			window.PRINT_STATUS = "PENDING"; 
			(function() {
			    var beforePrint = function() {
			       window.PRINT_STATUS = "PENDING";
			    };
			    var afterPrint = function() {
			        window.PRINT_STATUS = "DONE";
			    };
			    if (window.matchMedia) {
			        var mediaQueryList = window.matchMedia(/print/g);
			        mediaQueryList.addListener(function(mql) {
			            if (mql.matches) {
			                beforePrint();
			            } else {
			                afterPrint();
			            }
			        });
			    }
			    window.onbeforeprint = beforePrint;
			    window.onafterprint = afterPrint;
			}());
			function printTicket() {
				this.print(); 
				return 0;
			}
		</script>
`;

export function ReservationPrinter(props){
	const codeList = props.codeList;
	const conf = getConfiguration();
	const aamsEnviroment = !conf.nas;
	const [customerLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/customer-logo/${conf.logo}`, true);
	const [aamsLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/loghi_aams.svg`, aamsEnviroment);
	const goOnWithPrint = (customerLogo && (!aamsEnviroment || aamsLogo));
	
	useEffect(() => {
		if(!goOnWithPrint){
			return;
		}
		
		let htmlCodeWithScript = renderToString(<ReservationTicket codeList={codeList} customerLogo={customerLogo} aamsLogo={aamsLogo} />);
		
		htmlCodeWithScript = `<html>${stylePrintScript}${htmlCodeWithScript}</html>`;
		
		const iframe = document.createElement('iframe');
		$(iframe).attr({
			style : "height: 0px; margin: 0px; position: absolute; z-index: 1000000; border: solid 0px transparent; top: 0; left: 0;",
			id : "receipt-print-ticket",
			src : "#" + new Date().getTime()
		});
		iframe.doc = null;
		iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
		iframe.autofocus = true;
		// HTML INJECT!
		iframe.srcdoc = htmlCodeWithScript;
		iframe.addEventListener('load', function() {		            
			const cw = iframe.contentWindow;
            cw.focus();
            cw.printTicket();	// invoking the window.print in the iframe	
			let unlockInterval = setInterval(() =>{
				try{
					if(iframe.contentWindow.PRINT_STATUS === 'DONE'){
						// print done! close everything
						clearInterval(unlockInterval);
						console.log("PRINT DONE!");
						$("#receipt-print-ticket").remove();
						props.endFunction();
					}
				}
				catch(e){
					clearInterval(unlockInterval);
					console.error("PRINT EXCEPTION: " + e);
					console.error("Print dialog closed");
					props.endFunction();
				}

			},150);	
		});
		// on append finished, the frame 'on load' event listener will be triggered
		document.body.appendChild(iframe);
		
		/*
		// I show the hidden frame if the developer need to do that
		$(iframe).css({
			"position" : "absolute",
			"z-index" : 2000,
			"height" : "20000px",
			"background-color" : "white"
		})
		*/
	
	}, [goOnWithPrint])
	
	
	return null;
}


function ReservationTicket(props){
	return <body>
		<div className="logosContainer">
			<img className="customerLogo" src={props.customerLogo} />
			{props.aamsLogo && <img className="aamsLogo" src={props.aamsLogo} />}
		</div>
		{
			props.codeList.map((code, index) => {
				const type = getReservationCodeType();
				const barcodeImg = type !== 'qrCode'? getBarcode(code) : null;
				return <div className="codeContainer" key={index}>
					{barcodeImg && <img src={barcodeImg} />}
					{type === 'qrCode' && <> 
						<QRCode value={code} size="140"  />
						<div className="qrcodeLabel"> {code} </div>
					</>
					}
					
				</div>
			})
		}
	
	</body>
}